
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaitaxifare() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Taxi Fare  ',
        heading: 'Meghana Cab : Pune to Mumbai Taxi Fare  ',
        headingDescription: 'Meghana Cab offers transparent and affordable Pune to Mumbai Taxi Fare, ensuring value for money without compromising on comfort and safety. Whether you are traveling solo or in a group, our fleet includes Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers to suit every budget and need. Enjoy fixed pricing with no hidden charges, professional drivers, clean vehicles, and on-time service. Our Pune to Mumbai route covers major pickup points and provides door-to-door convenience. Book with Meghana Cab today for a reliable journey and know your Pune to Mumbai Taxi Fare upfront—no surprises, just smooth travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Taxi Fare Pune to Mumbai",
        "description": "Get clear and competitive taxi fare details for your Pune to Mumbai trip. Our transparent pricing ensures you know exactly what you're paying for, with no surprises or hidden charges at the end of the ride."
    },
    {
        "name": "Pune to Mumbai Cab Rates",
        "description": "Explore updated cab rates from Pune to Mumbai across various vehicle categories including sedans, SUVs, and premium cars. Perfect for travelers seeking the right balance between cost and comfort."
    },
    {
        "name": "Estimated Cab Fare Pune to Mumbai",
        "description": "Use our fare estimator to check the approximate cost for your Pune to Mumbai cab journey. Plan your trip confidently with pricing that considers vehicle type, route, and distance."
    },
    {
        "name": "Affordable Fare Taxi Pune to Mumbai",
        "description": "Looking for budget-friendly options? Our affordable fare taxi service from Pune to Mumbai provides quality rides at low prices—ideal for regular travelers, students, and small families."
    },
    {
        "name": "Low Cost Pune to Mumbai Cab",
        "description": "Our low-cost cab services from Pune to Mumbai are perfect for economical travel without compromising safety and reliability. Choose from compact cars or basic sedans to suit your budget."
    },
    {
        "name": "Online Fare Estimate Pune to Mumbai Taxi",
        "description": "Quickly calculate your Pune to Mumbai taxi fare online with our intuitive fare estimator. Just enter basic trip details and get an instant quote based on live pricing and cab availability."
    },
    {
        "name": "Transparent Taxi Charges Pune to Mumbai",
        "description": "We believe in complete fare transparency. With us, what you see is what you pay—no hidden fees, night surcharges, or dynamic pricing games. Get honest and upfront taxi charges every time."
    },
    {
        "name": "Price List Pune to Mumbai Cabs",
        "description": "Access our detailed price list for Pune to Mumbai cab services, including rates for sedans, SUVs, and luxury cars. Compare options easily and choose what fits your needs and budget best."
    },
    {
        "name": "Pune to Mumbai Per Km Taxi Rate",
        "description": "Understand the per kilometer taxi rate for Pune to Mumbai travel across various vehicle types. Ideal for those who prefer cost-based calculations and planning ahead based on distance."
    },
    {
        "name": "Budget Fare Cab Pune Mumbai",
        "description": "Travel smart with our budget fare cab options between Pune and Mumbai. These services are tailored for value seekers looking for dependable intercity transport without breaking the bank."
    },
    {
        "name": "Pune to Mumbai Fare Comparison",
        "description": "Compare fares across different cab types and service levels from Pune to Mumbai. Our side-by-side comparison helps you make informed decisions based on cost, comfort, and travel time."
    },
    {
        "name": "AC Taxi Fare Pune to Mumbai",
        "description": "Get fare details for air-conditioned taxi rides from Pune to Mumbai. Ideal for those looking for a cool, clean, and relaxing travel experience with transparent pricing."
    },
    {
        "name": "SUV Fare Pune to Mumbai Cab",
        "description": "Check the fare for SUV cabs from Pune to Mumbai—great for groups or luggage-heavy trips. Our pricing is competitive and includes all essentials like tolls, driver charges, and fuel."
    },
    {
        "name": "Sedan Fare Estimate Pune to Mumbai",
        "description": "Plan your journey with a clear fare estimate for sedan cabs from Pune to Mumbai. Perfect for professionals, couples, or small families who prefer comfort and affordability combined."
    },
    {
        "name": "Fare Breakdown Pune to Mumbai Taxi Trip",
        "description": "See a complete fare breakdown for your Pune to Mumbai taxi trip including base fare, per km charge, tolls, and driver fees. Full transparency lets you travel with peace of mind."
    }
],
"tableData": [
    ["Taxi Fare Pune to Mumbai", "Pune to Mumbai Cab Rates"],
    ["Estimated Cab Fare Pune to Mumbai", "Affordable Fare Taxi Pune to Mumbai"],
    ["Low Cost Pune to Mumbai Cab", "Online Fare Estimate Pune to Mumbai Taxi"],
    ["Transparent Taxi Charges Pune to Mumbai", "Price List Pune to Mumbai Cabs"],
    ["Pune to Mumbai Per Km Taxi Rate", "Budget Fare Cab Pune Mumbai"],
    ["Pune to Mumbai Fare Comparison", "AC Taxi Fare Pune to Mumbai"],
    ["SUV Fare Pune to Mumbai Cab", "Sedan Fare Estimate Pune to Mumbai"],
    ["Fare Breakdown Pune to Mumbai Taxi Trip", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Mumbai Taxi Fare Options",
        "WhyChoosedescription": "We offer budget-friendly taxi fare options for one-way and round-trip journeys between Pune and Mumbai. Whether you're a solo traveler or a group, our pricing plans are designed to suit all budgets without compromising on comfort or service quality."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our fare structure is fully transparent. What you see is what you pay—no surprise costs after booking. All fares include driver charges, tolls, taxes, and fuel, so you can plan your trip knowing the full cost upfront with complete clarity."
    },
    {
        "WhyChooseheading": "Flexible Fare Packages for Every Need",
        "WhyChoosedescription": "Choose from a variety of taxi fare packages based on your travel requirements. We offer fixed-rate one-way fares, hourly rentals, and customizable round-trip options to give you full control over your travel costs and schedule."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options to Match Your Budget",
        "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or premium cars based on your budget and group size. Economy vehicles offer great savings, while premium cars provide extra comfort—each with pricing tailored to the specific class of vehicle you choose."
    },
    {
        "WhyChooseheading": "Special Discounts for Online and Advance Bookings",
        "WhyChoosedescription": "Save more when you book in advance or online. We offer regular promotional fares, special deals on return trips, and exclusive discounts for corporate bookings and frequent travelers. Get the best rates by planning ahead!"
    },
    {
        "WhyChooseheading": "Detailed Fare Breakdown Before You Ride",
        "WhyChoosedescription": "Before your ride begins, you’ll receive a detailed fare summary including base fare, applicable tolls, and any other charges. This ensures complete transparency and allows you to travel confidently without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Value-Added Services Included in Fare",
        "WhyChoosedescription": "Our Pune to Mumbai taxi fare includes value-added services such as luggage assistance, on-time pickup, professional driver service, and complimentary waiting time at pickup. Enjoy more than just a ride—get great value for every rupee spent."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Fare Inquiries",
        "WhyChoosedescription": "Need help understanding your fare? Our customer support team is available around the clock to explain fare details, suggest the most cost-effective option, or help with fare-related queries before, during, or after your trip."
    }
]

















    }

const faqData = [
    {
        question: "What is the taxi fare from Pune to Mumbai with Meghana Cab?",
        answer: "Our fares start from ₹2,499 for a one way trip, depending on the car type and time of travel. Call us for an exact quote."
    },
    {
        question: "What factors affect the Pune to Mumbai taxi fare?",
        answer: "Taxi fare depends on the vehicle selected, time of travel (day/night), and whether it’s a one way or round trip."
    },
    {
        question: "Is the fare inclusive of tolls and driver charges?",
        answer: "Yes, our fare includes fuel, tolls, and driver charges. Any additional stops or waiting time may incur extra charges."
    },
    {
        question: "Do you offer fixed rates for Pune to Mumbai taxi service?",
        answer: "Yes, we offer fixed and transparent pricing with no hidden charges. What you see is what you pay."
    },
    {
        question: "Are there night charges for late evening or early morning travel?",
        answer: "Yes, an additional night charge may apply for travel between 10 PM and 6 AM. Please confirm at the time of booking."
    },
    {
        question: "Can I get a fare estimate before booking the taxi?",
        answer: "Absolutely! Just call us at +91 9075462128 or check online to get an instant fare estimate based on your travel details."
    },
    {
        question: "Do you offer any discounts or special fares for regular customers?",
        answer: "Yes, we often run promotions and offer special rates for corporate or repeat customers. Ask our team for current offers."
    },
    {
        question: "Are round trip fares cheaper than two one way bookings?",
        answer: "Yes, round trip bookings are generally more cost-effective compared to booking two separate one way rides."
    },
    {
        question: "Is GST included in the fare or charged separately?",
        answer: "GST is typically included in the quoted fare, but please confirm during booking for complete clarity."
    },
    {
        question: "How can I pay the taxi fare after the trip?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments at the end of your ride."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Manish Khandelwal',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab gave me the best fare for my Pune to Mumbai trip. No surprises or hidden fees—very professional.”',
    },
    {
        name: 'Ms. Anjali Suresh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Affordable taxi service with clear fare structure. Booking was easy and the ride was smooth. Will use again!”',
    },
];

















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Taxi Fare",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-taxi-fare.jpg",
  "description": "Check the affordable taxi fare from Pune to Mumbai with Meghana Cabs. Get transparent pricing, online fare estimates, and flexible options in AC Sedans, SUVs, and more. Book now for budget-friendly travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-taxi-fare"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Taxi Fare | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Know the exact taxi fare from Pune to Mumbai with Meghana Cabs. Get affordable rates, per km pricing, and online fare estimates for AC Sedans, SUVs, and more. Transparent charges. Book now!" 
  />
  <meta 
    name="keywords" 
    content="Taxi Fare Pune to Mumbai, Pune to Mumbai Cab Rates, Estimated Cab Fare Pune to Mumbai, Affordable Fare Taxi Pune to Mumbai, Low Cost Pune to Mumbai Cab, Online Fare Estimate Pune to Mumbai Taxi, Transparent Taxi Charges Pune to Mumbai, Price List Pune to Mumbai Cabs, Pune to Mumbai Per Km Taxi Rate, Budget Fare Cab Pune Mumbai, Pune to Mumbai Fare Comparison, AC Taxi Fare Pune to Mumbai, SUV Fare Pune to Mumbai Cab, Sedan Fare Estimate Pune to Mumbai, Fare Breakdown Pune to Mumbai Taxi Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaitaxifare;